













































import MessageForm from '@/components/MessageForm.vue'
import { EPermission } from '@/laura-types'
import Modal from '@/layouts/Modal.vue'
import { QBtn, QCard, QCardActions, QCardSection, QIcon, QSeparator } from 'quasar'
import { transformDate } from 'src/domains/date'
import { deleteMessage, IMessage, updateMessage } from 'src/store/messages'
import striptags from 'striptags'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { IVxsPromise, vxsActionFetch } from 'vuex-xhr-state'

@Component({
  components: {
    QCard,
    QCardSection,
    QCardActions,
    QSeparator,
    QIcon,
    QBtn,
    Modal,
    MessageForm,
  },
})
export default class Message extends Vue {
  @Prop({ required: true, type: Object }) public message!: IMessage
  @vxsActionFetch(deleteMessage) private removeMessage!: (_: number) => IVxsPromise<void>
  @vxsActionFetch(updateMessage) public updateMessage!: (_: Partial<IMessage>) => IVxsPromise<void>
  public editModal = false

  get strippedMessage(): string {
    const allowedTags = ['a', 'br', 'strong']
    return striptags(this.message.content, allowedTags)
  }

  public getFormattedCreatedAt(v: string): string {
    return transformDate(v)
  }

  public openEditModal(): void {
    this.editModal = true
  }

  public confirmDelete(): void {
    this.$q.dialog({
      title: 'Verwijderen',
      message: 'Weet je zeker dat je dit bericht wilt verwijderen?',
      cancel: {
        color: 'primary',
      },
      ok: {
        color: 'red',
        label: 'Verwijderen',
      },
    }).onOk(() => {
      this.removeMessage(this.message.id).then(() => {
        this.$emit('update')
      })
    })
  }

  get showAdminActions(): boolean {
    return this.$can('update', EPermission.LIKA_ADMIN)
  }

  get icon(): string {
    switch (this.message.type) {
      case 'info':
        return 'info'
      case 'critical':
        return 'warning'
      default:
        return this.message.type
    }
  }
}
